// Simple event bus for Vue 3 (no external deps)
const eventToHandlersMap = new Map();

function on(eventName, handler) {
  if (!eventToHandlersMap.has(eventName)) {
    eventToHandlersMap.set(eventName, new Set());
  }
  eventToHandlersMap.get(eventName).add(handler);
}

function off(eventName, handler) {
  const handlers = eventToHandlersMap.get(eventName);
  if (!handlers) return;
  handlers.delete(handler);
  if (handlers.size === 0) {
    eventToHandlersMap.delete(eventName);
  }
}

function emit(eventName, ...args) {
  const handlers = eventToHandlersMap.get(eventName);
  if (!handlers || handlers.size === 0) return;
  for (const handler of Array.from(handlers)) {
    try {
      handler(...args);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`[eventBus] handler for "${eventName}" threw`, error);
    }
  }
}

export default { on, off, emit };


